import { Component, OnInit } from '@angular/core';
import { AlertController, LoadingController, NavController, Platform, ToastController, PopoverController } from "@ionic/angular";
import { Location } from "@angular/common";
import { RestService } from "../../services/rest.service";
import { UtilService } from "../../services/util.service";
import { ActivatedRoute, Router } from '@angular/router';
import { LangService } from "../../services/lang.service";
import { GoogleAuth } from "@codetrix-studio/capacitor-google-auth";
import { PendingPayLoginService } from '../../services/pending-pay-login.service';
import { Capacitor } from '@capacitor/core';
import { OAuthProvider, signInWithPopup } from 'firebase/auth';
import { Auth, UserCredential } from '@angular/fire/auth';
import { SignInWithApple, SignInWithAppleOptions, SignInWithAppleResponse } from '@capacitor-community/apple-sign-in';
import { Device } from '@capacitor/device';
import { InstagramPopoverComponent } from 'src/app/popover/instagram/instagram.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-suscriptions',
  templateUrl: './suscriptions.page.html',
  styleUrls: ['./suscriptions.page.scss'],
})
export class SuscriptionsPage implements OnInit {
  showOverSearch: boolean;
  searchTop: any;
  helpFocus: boolean;
  isMobile: boolean;
  loadMostWanted: any;
  showModalLogin: boolean;
  availableSubscriptions: any;
  subscriptionId: any;
  user: any;
  couponCode: any;
  errorMsg: any;
  dataCoupon: any;
  auxCoupon: boolean;
  refCode: string;
  coupon: any;
  errorCoupon: boolean;
  userSubscriptions: any;
  profile: any;
  modeIosPrice: boolean = false;
  infoPlatform: any;
  showModalCancelSubscription: boolean;
  isInstagramWebView: boolean = false;

  constructor(public navCtrl: NavController,
    private locationRouter: Location,
    public platform: Platform,
    public rest: RestService,
    public util: UtilService,
    public loadingCtrl: LoadingController,
    public alertCtrl: AlertController,
    private route: ActivatedRoute,
    private saveRouter: Router,
    private toastController: ToastController,
    private langService: LangService,
    public toastCtrl: ToastController,
    public pendingPayLoginService: PendingPayLoginService,
    private auth: Auth,
    private popoverController: PopoverController,
    private translate: TranslateService
  ) {

    Device.getInfo().then(info => {
      this.infoPlatform = info.operatingSystem;
      //console.log('infoPlatform', this.infoPlatform);
      if (this.platform.is('android') || this.platform.is('ios')) {
        this.isMobile = true;
        if (this.platform.is('ios') && this.infoPlatform === 'ios') {
          if (this.platform.is('mobileweb')) {
            this.modeIosPrice = false;
          } else {
            this.modeIosPrice = true;
          }
        }
      }
    });

    this.isInstagramWebView = navigator.userAgent.includes('Instagram');
  }

  async presentPopover() {
    const popover = await this.popoverController.create({
      component: InstagramPopoverComponent,
      cssClass: 'custom-popover',
      translucent: true
    });
    return await popover.present();
  }

  ngOnInit() {
    if (this.pendingPayLoginService.showPendingPayLogin) {
      this.subscribe();
    }
    this.rest.getStorage('user').then(async (val) => {
      this.user = val;
      console.log('mmij user', this.user);
      console.log('mmij user2', this.user?.subscriptions[0]?.subscription.active);
      this.getSubscriptions();
      if (this.user) {
        await this.loadProfile();
      }
    });

    if (this.isInstagramWebView) { this.presentPopover(); }
  }

  ionViewDidEnter() {
    if (this.pendingPayLoginService.showPendingPayLogin) {
      this.subscribe();
    }

    this.rest.getStorage('coupon').then((val) => {
      if (val) {
        this.dataCoupon = val;
        this.auxCoupon = true;
        this.errorCoupon = false;
        this.couponCode = val.coupon_name;
        console.log('coupon', this.coupon);
      }
    });

    this.rest.getStorage('user').then((val) => {
      this.user = val;
      console.log('user', this.user);
      this.getSubscriptions();
      if (this.user) {
        this.loadProfile();
      }
    });
  }

  outData(ev) {
    if (ev && ev.editProfile) {
      this.navCtrl.navigateForward('mi-perfil');
    }

    if (ev && ev.focus) {
      this.showOverSearch = true;
      if (ev.search === '') {
        this.searchTop = '';
      }
      setTimeout(() => {
        this.helpFocus = true;
      }, 1800);
    }

    if (ev && ev.login) {
      // this.openLogin();
      this.navCtrl.navigateRoot('/login');
    }

    if (ev && ev.home) {
      const url = '/home';
      this.locationRouter.go(url);
    }

    if (ev && ev.referred) {
      let url = '/referred';
      this.navCtrl.navigateRoot(url);
    }

    if (ev && ev.old) {
      // this.navCtrl.navigateRoot('/registro')
      this.gotoOldApp(ev.view);
    }


    if (ev && ev.search) {
      //console.log(ev.search);
      this.searchTop = ev.search;

    }

    if (ev && typeof ev.isMobile === 'boolean') {
      // console.log(ev);
      this.isMobile = ev.isMobile;
    }

  }
  gotoOldApp(view?) {
    //console.log(view);

    if (view) {
      this.navCtrl.navigateForward(view);
    } else {
      window.open('https://louderband.com/', '_self');
    }
  }
  outData2(ev) {
    //console.log(ev);
    if (ev.banners) {
      // this.banners = ev.banners
    }
    if (ev && ev.blur) {
      this.showOverSearch = false;
      this.searchTop = null;
      this.helpFocus = false;
    }
  }

  modalLogin() {
    this.showModalLogin = true;
  }
  showCancelSubscription() {
    this.showModalCancelSubscription = !this.showModalCancelSubscription;
  }

  async cancelSubscription(comment: any) {


    if (this.user.subscriptions.length > 0) {
      const loading = await this.loadingCtrl.create({
        message: ''
      });
      await loading.present();
      const formData: any = new FormData();
      formData.append('user_comment', comment.value);
      formData.append('subscription_purchased_id', this.user.subscriptions[0].id);
      formData.append('user', this.user.id);
      formData.append('order', JSON.stringify(this.user.subscriptions[0].order));

      this.rest._post('subscription/unsubscribe', formData).subscribe(async (res: any) => {

        if (res && res.status === 200) {
          // loader.dismiss();
          const toast = await this.toastCtrl.create({
            message: 'Cancelando suscripcion',
            duration: 3000,
            position: 'middle'
          });

          this.rest.getStorage('user').then((val) => {
            this.user = val;
            if (this.user) {
              this.loadProfile();
            }
          })
          await toast.present();
          this.showCancelSubscription();
          this.gotoCanceledSuscriptionPage(res.body.due_data);

        }
      }, async (error) => {
        if (error) {
          const alert = await this.alertCtrl.create({
            header: 'Error',
            cssClass: 'custom-alert',
            subHeader: error.message,
            message: error.error.error,
            buttons: ['OK'],
          });

          await alert.present();
        }
        await loading.dismiss();
      });
      await loading.dismiss();

    }

  }
  redirectToHome() {
    // this.rest.storageSet('user');
    window.open('home/', '_self');
  }

  gotoCanceledSuscriptionPage(date: any) {
    this.navCtrl.navigateRoot('/subscriptionscanceled/' + date);
  }

  gotoRegister() {
    this.showModalLogin = false;
    const currentRoute = this.saveRouter.url;
    localStorage.setItem('currentRoute', currentRoute);
    this.pendingPayLoginService.payAfterLogin(true);
    this.navCtrl.navigateForward('/registro');
  }
  gotoLogin() {
    this.showModalLogin = false;
    const currentRoute = this.saveRouter.url;
    localStorage.setItem('currentRoute', currentRoute);
    this.pendingPayLoginService.payAfterLogin(true);
    this.navCtrl.navigateForward('/login');
  }
  gotoHome() {
    this.showModalLogin = false;
    this.navCtrl.navigateRoot('/home');
  }

  closeModalLogin() {
    this.showModalLogin = false;
  }

  async loginGoogle() {
    this.showModalLogin = false;
    const result = await GoogleAuth.signIn();
    console.log(result);

    const loading = await this.loadingCtrl.create({
      message: ''
    });
    loading.present();
    this.rest._post('google/login', result).subscribe(async (response) => {
      const user: any = response.body;
      this.rest.storageSet('user', user);
      this.util.setUser(user);
      this.util.setToken(user.token);

      loading.dismiss();

      let picture = null;

      // if (user.created_red_social) {
        /*this.navCtrl.push(RegisterPageTwo, {
          createdBySocial: true,
          user,
          name: user.name,
          profile_image: picture,
        });*/
      // } else {
        setTimeout(() => {
          this.navCtrl.navigateRoot('suscripciones');
          window.localStorage.setItem('louderbandToken', user.token);
        }, 300);
      // }
    }, (error) => {
      console.error('error: ', error);
      loading.dismiss();
      // this.loadingModal(error.message);
    });

  }

  async getAvailableSubscriptions() {
    const loading = await this.loadingCtrl.create({});
    loading.present();


    this.rest._get('subscription/list').subscribe(async (response) => {
      const res: any = response.body;
      this.availableSubscriptions = res;
      console.log('available subscriptions', this.availableSubscriptions);
      this.subscriptionId = this.availableSubscriptions[0].id;

      console.log('available subscriptions', res);
      loading.dismiss();
    }, (error) => {
      loading.dismiss();
      console.error('error subscriptions: ', error);
    });
  }

  async checkCoupon() {
    let loading = await this.loadingCtrl.create({});
    loading.present();
    const body = {
      id: this.subscriptionId,
      type: 'SUBSCRIPTION',
      coupon: this.couponCode,
      force_web_price: 1,
    };
    this.dataCoupon = null;
    this.errorMsg = null;

    let apiHelp = '';
    if (this.user != null && (this.user.premium === 'S' || 'N')) {
      apiHelp = 'coupons/validate';
    } else {
      apiHelp = 'coupons/guest/validate';
    }

    this.rest._post(apiHelp, body).subscribe(async response => {
      const res: any = response.body;
      if (res) {
        loading.dismiss();
        if (res.estado == 'success') {
          this.dataCoupon = res;
          this.auxCoupon = true;
          this.errorCoupon = false;
          this.rest.storageSet('coupon', res);
        } else {
          this.errorMsg = res.mensaje;
          this.rest.storageSet('coupon', null);
        }
      } else {
        loading.dismiss();
        this.errorCoupon = true;
        console.log('error');
      }
    }, async (error) => {
      loading.dismiss();
      this.errorMsg = error.error.mensaje;
      this.errorCoupon = true;
      console.log(error);
    });
  }

  removeCoupon() {
    this.auxCoupon = false;
    this.dataCoupon = null;
    this.couponCode = null;
    this.errorMsg = null;
    this.errorCoupon = false;
    this.rest.storageSet('coupon', null);
  }

  buySubscriptionNormal(loader, aux) {
    aux.force_web_price = 1;

    this.rest._post('subscription/purchase', aux).subscribe(async res => {
      if (res) {
        loader.dismiss();
        const toast = await this.toastCtrl.create({
          message: this.translate.instant('CONTINUE_PAYMENT'),
          duration: 2000,
          position: 'middle'
        });
        await toast.present();
        this.goToPaymentGateway(res.body, 'buy');
      }
    }, async (error) => {
      const toast = await this.toastCtrl.create({
        message: error.error.error,
        duration: 2000,
        position: 'middle'
      });
      await toast.present();
      loader.dismiss();
    });
  }

  goToPaymentGateway(res, type: 'buy' | 'gift') {
    const valsend = res.paymentUrl;
    console.log('open ' + valsend);
    window.open(encodeURI(valsend), '_self');
  }

  async subscribe() {
    this.pendingPayLoginService.payAfterLogin(false);
    const loader = await this.loadingCtrl.create({});
    let aux: any = {
      subscription: this.availableSubscriptions[0].id,
      force_web_price: 1,
      url_coupon_code: this.refCode,
      email: this.user?.email
    };
    if (this.dataCoupon) {
      aux.coupon = this.dataCoupon.coupon_id;
      aux.subscription = this.dataCoupon.course_id;
    }
    loader.present();
    this.buySubscriptionNormal(loader, aux);
  }

  async getSubscriptions() {
    if (this.user) {
      let loading = await this.loadingCtrl.create({});
      loading.present();

      this.rest._get('subscription/purchased/list').subscribe(async (response) => {
        const res: any = response.body;
        this.userSubscriptions = res;

        console.log('purchased subscriptions', res);
        loading.dismiss();

      }, (error) => {
        loading.dismiss();
        console.error('error subscriptions: ', error);
      });
    }

    this.getAvailableSubscriptions();
  }

  async loadProfile() {
    const loading = await this.loadingCtrl.create({});
    await loading.present();

    this.rest._get('accounts/user-information/' + this.user.user_id).subscribe(async (response) => {
      const res: any = response.body;
      this.profile = res;

      console.log('profile', res);
      await this.rest.storageSet('user', res);
      await loading.dismiss();

    }, async (error) => {
      await loading.dismiss();
      console.error('error', error);
    });
  }

  loginApple() {
    if (Capacitor.getPlatform() === 'web') {
      this.appleWeb();
    } else {
      this.appleApp();
    }
  }

  async appleWeb() {

    const provider = new OAuthProvider('apple.com');

    signInWithPopup(this.auth, provider).then((result: UserCredential) => {
      console.log(result);
      if (result) {
        this.helpApple(result.user);
      }
    });
  }

  async appleApp() {

    let options: SignInWithAppleOptions = {
      clientId: 'com.louderband.ios',
      redirectURI: 'https://louderband-app.firebaseapp.com/__/auth/handler',
      scopes: 'email name',
      state: '12345',
      nonce: 'nonce',
    };
    SignInWithApple.authorize(options)
      .then((result: SignInWithAppleResponse) => {
        // Handle user information
        // Validate token with server and create new session
        this.helpApple(result);
      })
      .catch(error => {
        // Handle error
      });
  }

  async helpApple(response) {

    let params = {
      username: response.email,
      name: response.displayName,
      red_social: 'APPLE',
      id_usuario_red_social: response.uid,
      tokenApple: response.accessToken,
      email: response.email,
      respuesta: JSON.stringify(response),
      notification_id: '' //this.oneSignal.getPlayerId()
    };
    // alert(JSON.stringify(params));
    const loading = await this.loadingCtrl.create({
      message: ''
    });
    loading.present();
    this.rest._post('apple/login', params).subscribe(async (responseApple) => {
      const user: any = responseApple.body;
      this.util.setToken(user.token);
      this.rest.storageSet('user', user);
      loading.dismiss();
      let picture = null;

      // if (user.created_red_social) {
        /*this.navCtrl.push(RegisterPageTwo, {
          createdBySocial: true,
          user,
          name: response.fullName.givenName + response.fullName.familyName,
          profile_image: picture,
        });*/
      // } else {
        setTimeout(() => {
          this.navCtrl.navigateRoot('suscripciones');
          window.localStorage.setItem('louderbandToken', user.token);
        }, 300);
      // }
    }, (error) => {
      console.error('error: ', error);
      loading.dismiss();
      // this.loadingModal(error.message);
    });
  }
}
